import React, { useState, useEffect, useRef } from 'react';
import './CursorFollower.css';

/**
 * Custom cursor follower component
 * Adds a magnetic cursor effect that follows the mouse
 */
const CursorFollower = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const cursorRef = useRef(null);
  const dotRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const handleMouseOver = (e) => {
      const target = e.target;
      if (target.tagName === 'A' || target.tagName === 'BUTTON' || target.closest('.cursor-follower-hoverable')) {
        setIsHovering(true);
      }
    };

    const handleMouseOut = () => {
      setIsHovering(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseout', handleMouseOut);

    document.body.classList.add('has-cursor-follower');

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mouseout', handleMouseOut);
      document.body.classList.remove('has-cursor-follower');
    };
  }, []);

  useEffect(() => {
    if (cursorRef.current) {
      cursorRef.current.style.transform = `translate(${position.x}px, ${position.y}px) translate(-50%, -50%)`;
    }
    if (dotRef.current) {
      dotRef.current.style.transform = `translate(${position.x}px, ${position.y}px) translate(-50%, -50%)`;
    }
  }, [position]);

  return (
    <>
      <div
        ref={cursorRef}
        className={`cursor-follower ${isHovering ? 'hovering' : ''}`}
      />
      <div ref={dotRef} className="cursor-dot" />
    </>
  );
};

export default CursorFollower;
